<template>
    <div>
        <!--<div class="login">-->
            <!--<div class="main">-->
                <!--<div class="main-title">-->
                    <!--<span>音视频通信</span>-->
                <!--</div>-->
                <!--<div class="main-input">-->
                    <!--<input type="text" placeholder="请输入房间号">-->
                <!--</div>-->
                <!--<div class="main-button">-->
                    <!--<button>进入房间</button>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="main-web">
            <div class="video-demo">
                <div class="videoBox">
                    <div class="videoContent">
                        <div class="container-box">
                            <!--<div class="publisher">-->
                                <!--<button class="select-preview">关闭预览</button>-->
                                <!--<button class="push-stream">处理中...</button>&nbsp;&nbsp;-->
                                <!--<span class="streamType" style="display: none;">-->
                                    <!--<label for="cameraPublisher">推视频流</label>-->
                                    <!--<input-->
                                            <!--id="cameraPublisher"-->
                                            <!--value="cameraPublisher"-->
                                            <!--type="checkbox"-->
                                            <!--name="streamType"-->
                                            <!--checked-->
                                    <!--/>&nbsp;-->
                                    <!--<label for="screenPublish">推共享流</label>-->
                                    <!--<input-->
                                            <!--id="screenPublish"-->
                                            <!--value="screenPublish"-->
                                            <!--type="checkbox"-->
                                            <!--name="streamType"-->
                                    <!--/>-->
                                <!--</span>-->
                            <!--</div>-->
                            <div class="publisher" >
                                <span class="equipment">
                                    <label for="microphone">{{$t('interview.microphone')}}</label>
                                    <input
                                            id="microphone"
                                            value="microphone"
                                            type="checkbox"
                                            name="streamType"
                                            checked
                                    />&nbsp;
                                    <label for="camera">{{$t('interview.camara')}}</label>
                                    <input
                                            id="camera"
                                            value="camera"
                                            type="checkbox"
                                            name="streamType"
                                            checked
                                    />
                                </span>
                                <!--<button class="select-preview mute">静音</button>-->
                                <!--<button class="select-preview all-mute">全部静音</button>-->
                            </div>
                            <div class="local-video">
                                <video autoplay playsinline></video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer-box">
                <el-drawer
                        :title="$t('interview.roomMember')"
                        :visible.sync="isUserList"
                        direction="rtl"
                        size="16%">
                    <div class="remote-user-list">
                        <ul class="user-ul">

                        </ul>
                    </div>
                </el-drawer>
            </div>
            <div class="video-container"></div>
        </div>
        <div class="alert"></div>
    </div>
</template>

<script>
    import './index.css'
    import '@/components/Meeting/aliyun-webrtc-sdk-1.12.1.js'
    // import '@/components/Meeting/aliyun-webrtc-sdk.js'
    import './utils'
    import sha256 from './sha256'
    import $ from 'jquery'

    export default {
        name: "csvideo",
        data() {
            return {
                userName:'',
                channelId:'',
                infoData:'',
                isUserList:false,
                isVideoList:false,
                videoList:[{
                    displayName:'wwww'
                }],
                updateUserList:null,
                hasVideo:false,
                hasAudio:false,
                playId:'',
                playUserId:'',
                aliWebrtc:null
            }
        },
        methods: {
            //初始化aliWebrtc
            initVideo() {
                let that=this;
                // joinroom();
                function showAlert (msg) {
                    console.log(msg);
                }
                /**
                 * 分析远端用户信息
                 * @param {String} userId
                 */
                function getSubscribeInfo(userId) {
                    var userInfo = aliWebrtc.getUserInfo(userId);
                    var subscribeInfo = [], subscribeInfoArr = [], isSubAudio = false, isSubLarge = false, isSubSmall = false, isSubCamera = false, isSubScreen = false, isSubVideo = false;
                    if (userInfo) {
                        userInfo.streamConfigs.forEach(v => {
                            if (v.subscribed) {
                                subscribeInfo.push(v.label);
                                subscribeInfoArr.push(v);
                                v.type == "audio" ? isSubAudio = true : "";
                                v.type == "video" ? isSubVideo = true : "";
                                v.label == "sophon_video_camera_large" ? isSubLarge = true : "";
                                v.label == "sophon_video_camera_small" ? isSubSmall = true : "";
                                v.label == "sophon_video_screen_share" ? isSubScreen = true : "";
                                if (isSubLarge || isSubSmall) {
                                    isSubCamera = true;
                                }
                            }
                        });
                    }
                    return { subscribeInfo: subscribeInfo, subscribeInfoArr: subscribeInfoArr, isSubLarge: isSubLarge, isSubSmall: isSubSmall, isSubCamera: isSubCamera, isSubAudio: isSubAudio, isSubScreen: isSubScreen, isSubVideo: isSubVideo };
                }
                /**
                 * 请找到 GenerateAliRtcAuthInfo方法，配置appId、appKey
                 */
                var channelId=this.channelId;
                var userName = this.userName;
                var publisherList = [];
                var aliWebrtc;
                aliWebrtc = new AliRtcEngine();
                this.aliWebrtc=aliWebrtc;
                /**
                 * AliWebRTC isSupport检测
                 */
                //阿里云检测设备信息
               aliWebrtc.getDevices().then((re) => {
                    if (re.videoDevices.length) {
                        this.hasVideo = true;
                    } else {
                        console.log('123')
                        this.hasVideo = false;
                    }
                    if (re.audioDevices.length) {
                        this.hasAudio = true;
                    } else {
                        this.hasAudio = false;
                    }
                    if (this.hasAudio&&this.hasVideo){
                        aliWebrtc.isSupport().then(re => {
                            joinroom();
                            init();
                        }).catch(error => {
                            alert(error.message);
                        })
                    } else {
                        alert(this.$t('interview.noCamaraOrMic'))
                        this.$router.push({name:'Login'})
                    }
                }).catch((error) => {
                    console.log(error.message)
                });


                //准备加入房间
                function init() {
                    /**
                     * remote用户加入房间 onJoin
                     * 更新在线用户列表
                     */
                    aliWebrtc.on("onJoin", (publisher) => {
                        if (publisher.userId) {
                            updateUserList();
                        }
                        //重置订阅状态
                        //默认订阅远端音频和视频大流，但需要调用subscribe才能生效
                        //这里取消默认订阅，根据需求进行订阅
                        aliWebrtc.configRemoteAudio(publisher.userId, false);
                        aliWebrtc.configRemoteCameraTrack(publisher.userId, false, false);
                        // showAlert(publisher.displayName + "加入房间","success");
                        console.log(publisher.displayName + "加入房间");
                        // 弹窗不重叠
                        setTimeout(() => {
                            that.$message.success(publisher.displayName+ that.$t('interview.joinRoom'))
                        }, 5);
                    });
                    /**
                     * remote流发布事件 onPublish
                     * 将该用户新增到推流列表
                     * 若该用户已存在推流列表，则进行状态更新
                     */
                    aliWebrtc.on("onPublisher", (publisher) => {
                        console.log("onPublisher", publisher);
                        let index = publisherList.getIndexByProprety(publisher.userId, "userId");
                        console.log(index);
                        if (index === -1) {
                            //新增
                            publisherList.push(publisher);
                            let streamTypeList = publisher.streamConfigs.filter(item => {
                                return item.state === "active";
                            });
                            console.log(streamTypeList);
                            streamTypeList.map(item => {
                                item.userId = publisher.userId;
                                receivePublishManual(item).then(re => {
                                    creatDomAndshowRemoteVideo(item);
                                    console.log("订阅成功");
                                });
                            })

                        } else {
                            //流状态更新
                            updatePublisherStream(publisher, index);
                        }
                    });

                    /**
                     * remote流结束发布事件 onUnPublisher
                     * 推流列表删除该用户
                     * 移除用户视图
                     * 初始化订阅状态
                     */
                    aliWebrtc.on("onUnPublisher", (publisher) => {
                        that.$message.success(publisher.displayName+ that.$t('interview.leaveRoom'))
                        console.log(publisher.displayName+"离开房间" );
                        detelePublisher(publisher.userId);
                        removeDom(publisher.userId);
                        initialization(publisher.userId);
                    });
                    /**this.$message.error(msg)
                     * 音量值回调
                     */
                    aliWebrtc.on("onAudioLevel", (data) => {
                        console.log('onAudioLevel',data)
                    })

                    /**this.$message.error(msg)
                     * 被服务器踢出或者频道关闭时回调 onBye
                     */
                    aliWebrtc.on("onBye", (message) => {
                        //1:被服务器踢出
                        //2:频道关闭
                        //3:同一个ID在其他端登录,被服务器踢出
                        var msg;
                        switch (message.code) {
                            case 1:
                                msg = "被服务器踢出";
                                break;
                            case 2:
                                msg = "频道关闭";
                                break;
                            case 3:
                                msg = "同一个ID在其他端登录,被服务器踢出";
                                break;
                            default:
                                msg = "onBye";
                        }
                        showAlert(msg, "danger");
                    });

                    /**
                     *  错误信息
                     */
                    aliWebrtc.on("onError", (error) => {
                        console.log(error)
                        var msg = error && error.message ? error.message : error;
                        if (msg && msg.indexOf("no session") > -1) {
                            msg = "请重新登录：" + msg;
                        }
                        if (error.errorCode === 10011 || error.errorCode === 10012) {
                            msg = error.errorCode === 10011 ? "屏幕共享被禁止" : "屏幕共享已取消";
                            setTimeout(() => {
                                $("#screenPublish").removeAttr("checked");
                                getPublishState("danger");
                            }, 2000);
                        }

                        if (error.code == 15) {
                            msg = "没有开启H5兼容";
                        }
                        if (error.type === "publish") {
                            // 提示用户网络状态不佳
                            console.log("推流断开 需要停止推流,然后重新推流");
                            // 先记录当前推流状态
                            var pubAudio = aliWebrtc.configLocalAudioPublish;
                            var pubCamera = aliWebrtc.configLocalCameraPublish;
                            var pubScreen = aliWebrtc.configLocalScreenPublish;
                            // 设置取消推流
                            aliWebrtc.configLocalAudioPublish = false;
                            aliWebrtc.configLocalCameraPublish = false;
                            aliWebrtc.configLocalScreenPublish = false;
                            aliWebrtc.publish().then(() => {
                                console.log("推流断开取消推流成功");
                                aliWebrtc.configLocalAudioPublish = pubAudio;
                                aliWebrtc.configLocalCameraPublish = pubCamera;
                                aliWebrtc.configLocalScreenPublish = pubScreen;
                                aliWebrtc.publish().then(() => {
                                    console.log("推流断开重新推流成功");
                                }).catch(err => {
                                    console.log("推流断开重新推流失败");
                                })
                            }).catch(err => {
                                console.log("推流断开取消推流失败");
                            })
                        }
                        if (error.type === "subscribe") {
                            console.log("订阅断开 取消订阅该userId的所有订阅并移除所有该userId的dom");
                            //先记录当前用户的订阅状态
                            var subInfo = getSubscribeInfo(error.userId);
                            //取消订阅状态
                            initialization(error.userId);
                            aliWebrtc.subscribe(error.userId).then(re => {
                                console.log("订阅断开 取消订阅成功");
                                aliWebrtc.configRemoteAudio(error.userId, subInfo.isSubAudio);
                                aliWebrtc.configRemoteCameraTrack(error.userId, subInfo.isSubLarge, subInfo.isSubCamera);
                                aliWebrtc.configRemoteScreenTrack(error.userId, subInfo.isSubScreen);
                                aliWebrtc.subscribe(error.userId).then(re => {
                                    console.log("订阅断开 重新订阅成功")
                                    if ($("#" + error.userId + "_camera")) {
                                        aliWebrtc.setDisplayRemoteVideo(error.userId, $("#" + error.userId + "_camera video")[0], 1)
                                    }
                                    if ($("#" + error.userId + "_screen")) {
                                        aliWebrtc.setDisplayRemoteVideo(error.userId, $("#" + error.userId + "_screen video")[0], 2)
                                    }
                                }).catch(err => {
                                    console.log("订阅断开 重新订阅失败");
                                    detelePublisher(error.userId);
                                    removeDom(error.userId);
                                })
                            }).catch(err => {
                                console.log("订阅断开 取消订阅失败", err)
                                detelePublisher(error.userId);
                                removeDom(error.userId);
                            });
                        }
                        showAlert(msg, "danger")
                    });

                    /**
                     * 检测到用户离开频道
                     * 更新用户列表
                     * 移除用户视图
                     */
                    aliWebrtc.on("onLeave", (publisher) => {
                        initialization(publisher.userId);
                        updateUserList();
                        removeDom(publisher.userId);
                        showAlert(publisher.displayName + '离开房间', "success");
                    })
                }

                /**
                 * 加入房间
                 * 触发：输入房间号、单击加入房间按钮
                 * 更新页面信息
                 * 默认开启预览
                 * 获取鉴权信息
                 * 加入房间
                 * 本地默认自动推视频流（视频流 + 音频流）
                 * 发布本地流
                 */
                function joinroom() {
                    $(".local-display-name .username b").text(userName);
                    $(".local-display-name .channelid b").text(channelId);
                    $(".local-display-name .streamstate b").text("当前未推流");
                    //1.预览
                    var localVideo = $(".local-video video");
                    aliWebrtc.startPreview(localVideo[0]).then((obj) => {
                        console.log("开启预览成功");
                    }).catch((error) => {
                        showAlert("[开启预览失败]" + error.message, "danger");
                    });
                    //2. 获取频道鉴权令牌参数 为了防止被盗用建议该方法在服务端获取
                    var authInfo = GenerateAliRtcAuthInfo(channelId);
                    //3. 加入房间 默认推音频视频流
                    aliWebrtc.joinChannel(authInfo, userName).then(() => {
                        showAlert("加入房间成功", "success");
                        // 4. 发布本地流
                        aliWebrtc.configLocalAudioPublish = true;
                        aliWebrtc.configLocalCameraPublish = true;
                        aliWebrtc.publish().then((res) => {
                            setTimeout(() => {
                                console.log("发布流成功");
                                $(".push-stream").text("停止推流");
                                $(".streamType").show();
                                $(".local-display-name .streamstate b").text("视频流");
                                updateUserList();
                            }, 2000)
                        }, (error) => {
                            $(".streamType").show();
                            showAlert("[推流失败]" + error.message, "danger");
                        });
                    }).catch((error) => {
                        showAlert("[加入房间失败]" + error.message, "danger");
                    })
                }

                /**
                 * 更新在线用户列表
                 */
                var updateUserList = () => {
                    $(".user-ul").empty();
                    let userList = aliWebrtc.getUserList();
                    let frg = document.createDocumentFragment();
                    userList.map((user) => {
                        let html = $("<li class='user-ul-li'>" + user.displayName + "<div class='menu'></div></li>");
                        $(html).bind("mouseover", user.userId, showUserMenu).bind("mouseleave", hideUserMenu);
                        frg.append(html[0]);
                    })
                    setTimeout(function () {
                        $(".user-ul").append($(frg));
                    }, 600)

                    console.log('更新用户列表',userList)
                }
                this.updateUserList=updateUserList;

                /*
                 * 获取测试token
                 * @param {*} channelId 频道号
                 * @return {object} authinfo
                 */
                var GenerateAliRtcAuthInfo = (channelId) => {
                    let userId = '';
                    var appId = "gwu2pxyn";// 修改为自己的appid 该方案仅为开发测试使用，正式上线需要使用服务端的AppServer
                    var appKey = "059973a2a6d1f363cd6ee320c50d0e35";// 修改为自己的appkey 该方案仅为开发测试使用，正式上线需要使用服务端的AppServer
                    userId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });// 可以自定义
                    var timestamp = parseInt(new Date().getTime() / 1000 + 48 * 60 * 60);
                    var nonce = 'AK-' + timestamp;
                    var token = sha256(appId + appKey + channelId + userId + nonce + timestamp);
                    return {
                        appid: appId,
                        userid: userId,
                        timestamp: timestamp,
                        nonce: nonce,
                        token: token,
                        gslb: ["https://rgslb.rtc.aliyuncs.com"],
                        channel: channelId
                    };
                }

                /**
                 * 获取当前remote用户的流菜单
                 */
                var showUserMenu = (evt) => {
                    let userId = evt.data;
                    if (!$(event.target).eq(0).hasClass("user-ul-li")) {
                        return
                    }
                    $(".menu").hide();
                    $(event.target).find(".menu").empty().show();
                    let userInfo = aliWebrtc.getUserInfo(userId);
                    let streamTypeList = userInfo.streamConfigs.filter(item => {
                        return item.state === "active";
                    });
                    var html = "";
                    if (streamTypeList.length == 0) {
                        html = $("<span>该用户未推流</span>");
                        $(event.target).find(".menu").append(html[0]);
                    } else {
                        var frg = document.createDocumentFragment()
                        streamTypeList.map(item => {
                            item.userId = userId;
                            var labelName = "";
                            if (item.type === "video") {
                                switch (item.label) {
                                    case "sophon_video_camera_large":
                                        labelName = "视频流";
                                        break;
                                    case "sophon_video_screen_share":
                                        labelName = "共享流";
                                        break;
                                    case "sophon_audio":
                                        labelName = "";
                                        break;
                                    default:
                                        labelName = "";
                                }
                            } else {
                                labelName = "";
                            }
                            //将音频流或小流的标签不显示
                            if (labelName !== "") {
                                let subState = item.subscribed === true ? "取消订阅" : "订阅";
                                html = $("<span>" + labelName + "&nbsp;<span class='subBtn'>" + subState + "</span></span>");
                                $(html).find("span").off("click").on("click", item, unSub);
                                frg.append(html[0]);
                            }
                        })
                        //是否显示订阅按钮
                        // $(event.target).find(".menu").append($(frg));
                    }
                }

                /**
                 * 隐藏当前remote用户的流菜单
                 */
                var hideUserMenu = () => {
                    $(event.currentTarget).find(".menu").hide();
                }

                /**
                 * 订阅&取消订阅
                 */
                var unSub = (evt) => {
                    console.log('订阅')
                    console.log(evt)
                    let v = evt.data;
                    if (v.subscribed) {
                        setConfigRemote(v.userId, v.label).then(re => {
                            removeDom(v.userId, v.label);
                            console.log("取消订阅");
                        });
                    } else {
                        receivePublishManual(v).then(re => {
                            creatDomAndshowRemoteVideo(v);
                            console.log("订阅成功");
                        });
                    }
                    $(".menu").hide();
                }


                /**
                 * 获取dom标签 设置video
                 */
                var creatDomAndshowRemoteVideo = (v) => {
                    console.log(v);
                    var dom = getDisplayRemoteVideo(v.userId, v.label);
                    if (v.label != "sophon_video_screen_share") {
                        aliWebrtc.setDisplayRemoteVideo(v.userId, dom, 1);
                    } else {
                        aliWebrtc.setDisplayRemoteVideo(v.userId, dom, 2);
                    }
                }

                /**
                 * 创建获取订阅的remote的video标签
                 */
                var getDisplayRemoteVideo = function (userId, label) {
                    var label = label === "sophon_video_camera_large" ? "camera" : "screen";
                    var id = userId + "_" + label;
                    var videoWrapper = $("#" + id);
                    if (videoWrapper.length == 0) {
                        var userInfo = aliWebrtc.getUserList().filter(item => {
                            return item.userId === userId;
                        })

                        var displayName = userInfo[0].displayName;
                        videoWrapper = $("<div class='remote-subscriber' id=" + id + "> <video autoplay playsinline></video><div class='display-name'></div><div class='list-video'><span class='no' style='display: none'><svg t=\"1637053756650\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"5232\" width=\"200\" height=\"200\"><path d=\"M544.62 159.86a36.076 36.076 0 0 0-38.35 4.95L298.99 337.32l-165.2-0.66h-0.13c-9.49 0-18.66 3.75-25.41 10.49a35.922 35.922 0 0 0-10.62 25.49l-0.75 288.29c0 9.61 3.75 18.78 10.53 25.54a35.78 35.78 0 0 0 25.5 10.61h167.16l206.25 171.87a36.024 36.024 0 0 0 38.37 4.95 36.036 36.036 0 0 0 20.74-32.66V192.46a36.144 36.144 0 0 0-20.81-32.6z m139.75 180.2c-17.81-8.34-39.01-0.79-47.54 16.93-8.52 17.84-1.2 39.22 16.46 48.09 2.3 1.19 56.28 29.25 56.28 109.13 0 85.38-50.48 113.67-52.17 114.57-17.82 8.91-25.04 30.58-16.13 48.4s30.58 25.04 48.4 16.13c3.77-1.9 91.97-47.56 91.97-179.11 0-126.88-93.31-172.26-97.27-174.14z m112.21-105.84c-16.66-10.63-38.78-5.82-49.52 10.77-10.76 16.66-6.1 38.88 10.45 49.82 3.92 2.58 96.23 65.49 96.23 222.09 0 156.93-88.58 219.9-92.1 222.31a36.054 36.054 0 0 0-15.97 32.31 36.053 36.053 0 0 0 19.99 29.99 36.048 36.048 0 0 0 35.97-2.32c5.07-3.36 124.18-85.02 124.18-282.3 0.01-197.68-123.94-279.3-129.23-282.67z m0 0\" p-id=\"5233\" fill=\"#ffffff\"></path></svg></span><span class='yes'><svg t=\"1637053820509\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"6098\" width=\"200\" height=\"200\"><path d=\"M100.1 399v221c0 30.5 24.7 55.3 55.3 55.3h82.9V343.7h-82.9c-30.5 0-55.3 24.8-55.3 55.3zM803 509.5l115.3-115.3c12.4-12.4 13.6-31.5 2.6-42.5s-30-9.9-42.5 2.6L763.1 469.6 647.9 354.3c-12.4-12.5-31.5-13.6-42.5-2.6s-9.9 30 2.6 42.5l115.3 115.3L608 624.8c-12.4 12.4-13.6 31.5-2.6 42.5s30 9.9 42.5-2.6l115.3-115.3 115.3 115.3c12.4 12.4 31.5 13.6 42.5 2.6s9.9-30-2.6-42.5L803 509.5zM486.9 178L293.5 306.9v405.2L486.9 841c30.5 0 55.3-24.7 55.3-55.3V233.2c-0.1-30.5-24.8-55.2-55.3-55.2z\" p-id=\"6099\" fill=\"#ffffff\"></path></svg></span></div><div class='openIcon'><svg t=\"1635839441171\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"2667\" width=\"200\" height=\"200\"><path d=\"M358.4 768H426.666667v85.333333H213.333333v-213.333333h85.333334v68.266667l128-128 59.733333 59.733333-128 128z m345.6 0l-128-128 59.733333-59.733333 132.266667 132.266666V640h85.333333v213.333333h-213.333333v-85.333333h64zM358.4 298.666667l128 128-59.733333 59.733333-128-128V426.666667H213.333333V213.333333h213.333334v85.333334H358.4z m345.6 0H640V213.333333h213.333333v213.333334h-85.333333V354.133333l-132.266667 132.266667-59.733333-59.733333 128-128z\" fill=\"#ffffff\" p-id=\"2668\"></path></svg></div></div>");
                        $(".video-container").append(videoWrapper);
                    }
                    // videoWrapper.find(".display-name").text(displayName + "—" + label);
                    videoWrapper.find(".display-name").text(displayName);
                    return videoWrapper.find("video")[0];
                }
                $(".video-container").on("click",".openIcon",function(event){
                    let id=$(this).parent().attr("id");
                    let userId=$(this).parent().attr("id").split('_')[0];
                    let videoDom =  $(".local-video video")[0];
                    console.log('1111')
                    if (that.playId){
                        if (that.playId!=id){
                            let oldDom=$("#"+that.playId + " video")[0];
                            aliWebrtc.subscribe(userId).then((userId) => {
                                aliWebrtc.setDisplayRemoteVideo(
                                    userId,       // 用户ID
                                    videoDom,        // html中用于显示stream对象的video元素
                                    1             // 1表示摄像头流（大流和小流），2表示屏幕分享流
                                )
                            }, (error) => {
                                console.log(error.message);
                            });
                            aliWebrtc.setDisplayRemoteVideo(that.playUserId, oldDom, 1);
                            setTimeout(() => {
                                that.playId=id;
                                that.playUserId=userId;
                            }, 1000);
                        }
                    } else {
                        aliWebrtc.setDisplayRemoteVideo(userId, videoDom, 1);
                        that.playId=id;
                        that.playUserId=userId;
                    }
                });
                $(".video-container").on("click",".list-video",function(event){
                    let userId=$(this).parent().attr("id").split('_')[0];
                    if ($(this).find(".no").css("display")=='none') {
                        aliWebrtc.muteRemoteAudioPlaying(userId, true);
                        $(this).find(".no").show();
                        $(this).find(".yes").hide();
                    }else {
                        aliWebrtc.muteRemoteAudioPlaying(userId, false);
                        $(this).find(".no").hide();
                        $(this).find(".yes").show();
                    }
                });


                /**
                 * 移除dom
                 */
                var removeDom = (userId, label) => {
                    if (label === "sophon_audio") return
                    console.log(userId)
                    if (userId) {
                        if (!label) {
                            $("#" + userId + "_camera").remove();
                            $("#" + userId + "_screen").remove();
                        } else {
                            label = label === "sophon_video_camera_large" ? "camera" : "screen";
                            $("#" + userId + "_" + label).remove();
                        }
                    }
                }

                /**
                 * 取消订阅设置
                 */
                var setConfigRemote = (userId, label) => {
                    return new Promise((resolve, reject) => {
                        //demo中只订阅大流
                        if (label === "sophon_video_camera_large") {
                            aliWebrtc.configRemoteCameraTrack(userId, false, false);
                            aliWebrtc.configRemoteAudio(userId, false);
                        } else if (label === "sophon_video_screen_share") {
                            aliWebrtc.configRemoteScreenTrack(userId, false);
                        }
                        aliWebrtc.subscribe(userId).then(re => {
                            resolve();
                        }).catch(error => console.log("取消订阅失败", error))
                    });
                }


                /**
                 * 订阅设置
                 */
                var receivePublishManual = (v) => {
                    console.log("receivePublishManual订阅", v);
                    return new Promise((resolve, reject) => {
                        if (v.label === "sophon_video_camera_large") {
                            console.log("订阅固定视频流");
                            aliWebrtc.configRemoteCameraTrack(v.userId, true, true);
                            aliWebrtc.configRemoteAudio(v.userId, true);
                        } else if (v.label === "sophon_video_screen_share") {
                            console.log("订阅屏幕共享流");
                            aliWebrtc.configRemoteScreenTrack(v.userId, true);
                        }
                        aliWebrtc.subscribe(v.userId).then(re => {
                            resolve();
                        }).catch((error) => {
                            reject(error);
                            showAlert("[subscribe失败]" + error.message, "danger");
                        });
                    })
                }

                /**
                 * 更新推流状态
                 * 当远端流发生变化时，通过onPublisher回调接收到信息
                 * 远端流不可用时其state值为inactive
                 * 通过对比本地维护的publisherList来进行dom的删除
                 * 并且更新本地维护的publisherList
                 */
                var updatePublisherStream = (publisher, index) => {
                    console.log(publisher);
                    let oldStreamConfigs = JSON.parse(JSON.stringify(publisherList[index].streamConfigs));
                    let newStreamConfigs = publisher.streamConfigs;
                    let subscribeInfo = getSubscribeInfo(publisher.userId);
                    console.log(oldStreamConfigs);
                    console.log(newStreamConfigs);
                    oldStreamConfigs.forEach((v, i, a) => {
                        let newStream = newStreamConfigs.getObjByProprety(v.label, "label");
                        // 判断流状态改变了 但不确定我们是否订阅了该流
                        if (v.state != newStream.state) {
                            console.log("流的状态变了" + v.label, v, v.type, ">" + v.state + ">>" + newStream.state + ">", newStream, subscribeInfo);
                            //并且要取消订阅某个流，不然就不能再次订阅了
                            subscribeInfo.subscribeInfoArr.forEach(sv => {
                                if (v.label === sv.label) {
                                    console.log("setConfigRemote取消订阅调用[api]:subscribe", publisher.userId, sv.type, sv.label);
                                    setConfigRemote(publisher.userId, sv.type, sv.label).then(re => {
                                        // 移除dom
                                        removeDom(publisher.userId, v.label);
                                    }).catch(error => {
                                        console.error("流的状态变了重新订阅出问题", error);
                                    });
                                }else {
                                    let streamTypeList = publisher.streamConfigs.filter(item => {
                                        return item.state === "active";
                                    });
                                    streamTypeList.map(item => {
                                        item.userId = publisher.userId;
                                        receivePublishManual(item).then(re => {
                                            creatDomAndshowRemoteVideo(item);
                                            console.log("订阅成功");
                                        });
                                    })
                                }
                            });
                        }
                    });
                    publisherList.splice(index, 1, publisher);
                }

                /**
                 * 用户停止推流时 删除用户列表中该用户
                 */
                var detelePublisher = (userId) => {
                    let index = publisherList.getIndexByProprety(userId, "userId");
                    if (index != -1) {
                        publisherList.splice(index, 1);
                        // this.detelePublisher(userId);
                    } else {
                        console.log("未找到之前的推流数据"); //删除推流用户
                    }
                }

                /**
                 * 正在推流时,热切换进行republish操作
                 */
                var rePublish = () => {
                    if ($(".publisher .push-stream").text() === "停止推流") {
                        $(".publisher .push-stream").text("处理中...");
                        $(".streamType").hide();
                        aliWebrtc.publish().then(re => {
                            setTimeout(() => {
                                getPublishState("success");
                            }, 2000);
                        }).catch(error => {
                            setTimeout(() => {
                                getPublishState("danger");
                            }, 2000);
                        });
                    }
                }

                /**
                 * 根据推流状态设置当前推流UI
                */
                var getPublishState = (type) => {
                    var streamstate = $(".streamstate b").text()
                    if (aliWebrtc.configLocalAudioPublish || aliWebrtc.configLocalCameraPublish || aliWebrtc.configLocalScreenPublish) {
                        $(".publisher .push-stream").text("停止推流");
                        if (aliWebrtc.configLocalScreenPublish && aliWebrtc.configLocalCameraPublish) {
                            streamstate = "视频流 + 共享流";
                        } else {
                            if (aliWebrtc.configLocalScreenPublish) {
                                streamstate = "共享流";
                            } else if (aliWebrtc.configLocalCameraPublish) {
                                streamstate = "视频流";
                            }
                        }
                    } else {
                        $(".publisher .push-stream").text("开始推流");
                        streamstate = "当前未推流";
                    }
                    showAlert("推流状态：" + streamstate, type);
                    $(".streamstate b").text(streamstate);
                    $(".streamType").show();
                }

                /**
                 * 进入房间
                 */
                $(".main-button button").click(() => {
                    console.log(123)
                    var value = $(".main-input input").val();
                    if (!value) {
                        showAlert("请输入房间号", "danger");
                        return
                    }
                    if (!aliWebrtc) {
                        showAlert("isSupport失败,未能初始化aliWebrtc", "danger");
                        return
                    }
                    channelId = this.channelId;
                    joinroom();
                    $(".login").hide();
                    $(".main-web").show();
                })
 /**
                 * 静音
                 */
                $(".mute").click(() => {
                    console.log($(".mute").text())
                    if ($(".mute").text()=='静音'){
                        aliWebrtc.muteLocalMic(true, false);
                        $(".mute").text('取消静音')
                    } else {
                        aliWebrtc.muteLocalMic(false, false);
                        $(".mute").text('静音')
                    }
                })
                $(".all-mute").click(() => {
                    if ($(".all-mute").text()=='全部静音'){
                        console.log('全部静音')
                        aliWebrtc.muteAllRemoteAudioPlaying(true)
                        $(".all-mute").text('取消静音')
                    } else {
                        aliWebrtc.muteAllRemoteAudioPlaying(false);
                        $(".all-mute").text('全部静音')
                    }
                })

                /**
                 * 控制预览
                 */
                $(".publisher .select-preview").click(function (e) {
                    var localVideo = $(".local-video video");
                    if ($(this).text() === "开启预览") {
                        $(this).text("处理中...");
                        aliWebrtc.startPreview(localVideo[0]).then((obj) => {
                            setTimeout(() => {
                                $(this).text("关闭预览");
                            }, 2500);
                        }).catch((error) => {
                            setTimeout(() => {
                                $(this).text("开启预览");
                            }, 2500);
                            showAlert("[关闭预览失败]" + error.message, "danger");
                        });
                    } else if ($(this).text() === "关闭预览") {
                        $(this).text("处理中...");
                        aliWebrtc.stopPreview().then((re) => {
                            setTimeout(() => {
                                $(this).text("开启预览");
                            }, 2500);
                        }).catch((error) => {
                            setTimeout(() => {
                                $(this).text("关闭预览");
                            }, 2500);
                            showAlert("[开启预览失败]" + error.message, "danger");
                        });
                    } else {
                        return
                    }
                })

                /**
                 * 控制推流选项
                 */
                $(".publisher .streamType input").click(function (e) {
                    var config = $(this).val();
                    var isChecked = $(this).prop("checked");
                    if (config === "cameraPublisher") {
                        if (isChecked) {
                            aliWebrtc.configLocalAudioPublish = true;
                            aliWebrtc.configLocalCameraPublish = true;
                        } else {
                            aliWebrtc.configLocalAudioPublish = false;
                            aliWebrtc.configLocalCameraPublish = false;
                        }
                    } else {
                        if (isChecked) {
                            aliWebrtc.configLocalScreenPublish = true;
                        } else {
                            aliWebrtc.configLocalScreenPublish = false;
                        }
                    }
                    //正在推流时可以热切换
                    rePublish();
                })
                /**
                 * 控制麦克风
                 */
                $(".publisher .equipment input").click(function (e) {
                    var config = $(this).val();
                    var isChecked = $(this).prop("checked");
                    console.log(config);
                    if (config === "microphone") {
                        if (isChecked) {
                            aliWebrtc.muteLocalMic(false, false);
                            console.log('取消静音了');
                        } else {
                            aliWebrtc.muteLocalMic(true, false);
                            console.log('静音了');
                        }
                    } else {
                        if (isChecked) {
                            aliWebrtc.configLocalAudioPublish = true;
                            aliWebrtc.configLocalCameraPublish = true;
                            aliWebrtc
                                .publish()
                                .then(re => {
                                    setTimeout(() => {
                                        // getPublishState("success");
                                        that.$message.success(that.$t('interview.pushSuccess'))
                                        console.log('开始推流成功')
                                    }, 2000);
                                    console.log('开始推流成功')
                                })
                                .catch(error => {
                                    showAlert("[开始推流失败]" + error.message, "danger");
                                });
                        } else {
                            aliWebrtc.configLocalAudioPublish = false;
                            aliWebrtc.configLocalCameraPublish = false;
                            aliWebrtc.configLocalScreenPublish = false;
                            aliWebrtc.unPublish().then((re) => {
                                setTimeout(() => {
                                    that.$message.success(that.$t('interview.stopPushSuccess'))
                                    console.log('停止推流成功')
                                }, 2000);
                            }, (error) => {
                                showAlert("[停止推流失败]" + error.message, "danger");
                            });
                        }
                    }
                    //正在推流时可以热切换
                    rePublish();
                })

                /**
                 * 处理推流
                 */
                $(".publisher .push-stream").click(function (e) {
                    if ($(this).text() === "开始推流") {
                        $(this).text("处理中...")
                        $(".streamType").hide()
                        aliWebrtc
                            .publish()
                            .then(re => {
                                setTimeout(() => {
                                    getPublishState("success");
                                }, 2000);
                            })
                            .catch(error => {
                                $(this).text("开始推流");
                                $(".streamType").show();
                                showAlert("[开始推流失败]" + error.message, "danger");
                            });
                    } else if ($(this).text() === "停止推流") {
                        $(this).text("处理中...");
                        $(".streamType").hide();
                        aliWebrtc.configLocalAudioPublish = false;
                        aliWebrtc.configLocalCameraPublish = false;
                        aliWebrtc.configLocalScreenPublish = false;
                        aliWebrtc.publish().then((re) => {
                            setTimeout(() => {
                                $("input[type='checkbox']").removeAttr("checked");
                                $(".streamType").show();
                                $(this).text("开始推流");
                                $(".local-display-name .streamstate b").text("当前未推流");
                            }, 2000);
                        }, (error) => {
                            $(".streamType").show();
                            showAlert("[停止推流失败]" + error.message, "danger");
                        });
                    } else {
                        return
                    }
                });

                /**
                 * 页面刷新时调用离会
                 */
                window.onbeforeunload = function (e) {
                    if (!aliWebrtc) {
                        showAlert("isSupport失败,未能初始化aliWebrtc", "danger");
                        return
                    }
                    aliWebrtc.leaveChannel();
                    aliWebrtc.dispose();
                };


            },
            tabClick(type){
                if (type=='1'){
                    this.updateUserList();
                    this.isUserList = true
                } else {
                    this.isUserList = false
                }
                if (type=='3'){
                    this.isVideoList = true
                } else {
                    this.isVideoList = false
                }
            },
            nameSet(name){
                return name.split('_')[1]
            },
            allMute(){
                console.log('123')
                console.log(this.aliWebrtc);
                this.aliWebrtc.muteAllRemoteAudioPlaying(true)
            },
            previewSelete(){
                let that=this;
                var localVideo = $(".local-video video");
                if (that.playId){
                    let oldDom=$("#"+that.playId + " video")[0];
                    that.aliWebrtc.setDisplayRemoteVideo(that.playUserId, oldDom, 1);
                    setTimeout(() => {
                        that.playId='';
                        that.playUserId='';
                        this.aliWebrtc.startPreview(localVideo[0]).then((obj) => {

                        }).catch((error) => {
                            console.log("[关闭预览失败]" + error.message, "danger");
                        });
                    }, 500);
                }

            }
        },
        mounted() {
            this.userName=this.nameSet(localStorage.getItem('userName'));
            this.channelId=localStorage.getItem('channelId');
            this.infoData=JSON.parse(localStorage.getItem('info'));
            this.initVideo();
        }
    }
</script>

<style scoped>
    .drawer-box >>> .el-drawer__header{
        background-color: #111827 ;
        color: #fff;
        padding: 20px;
        margin: 0;
    }
    .drawer-box >>> .el-drawer__body{
        background-color: #2e384c;
        color: #fff;
        padding: 20px;
        margin: 0;
    }
    .drawer-box >>> .el-drawer.rtl {
        right: 61px;
        top: 70px;
    }
</style>
